import { SyntheticEvent } from 'react';
import styled, { css } from 'styled-components';

import RoundingFramedIcon from '@r1-frontend/ui-kit/atoms/svg/RoundingFramedIcon';
import { MessageQuestion } from '@r1-frontend/ui-kit/atoms/svg/support';
import { H6 } from '@r1-frontend/ui-kit/atoms/typography/heading';
import { Text } from '@r1-frontend/ui-kit/atoms/typography/text';
import darkTheme from '@r1-frontend/ui-kit/themes/theme.dark';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

export type TButtonQuizProps = {
    /**
     * Основной текст кнопки
     */
    title?: string,
    /**
     * Дополнительное описание
     */
    subtitle?: string,
    /**
     * Коллбек, срабатывающий при клике на кнопку
     */
    onClick: (e: SyntheticEvent) => void,
}

const ButtonQuiz = styled(({
    title = 'Есть 1 минута?',
    subtitle = 'Оцените наш сайт',
    onClick,
    ...props
}: TButtonQuizProps): JSX.Element => {
    return <button {...props} onClick={onClick}>
        <RoundingFramedIcon>
            <MessageQuestion size={32}/>
        </RoundingFramedIcon>
        <div>
            <H6 $weight={'medium'} theme={darkTheme}>{title}</H6>
            <Text $weight='normal' $color='head' theme={darkTheme}>{subtitle}</Text>
        </div>
    </button>;
})`
    ${({ theme }: ThemedProperties) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.indents.xs}px;

    box-sizing: border-box;
    width: 220px;
    height: 56px;

    border: none;  
    cursor: pointer;
    font: inherit;

    background: linear-gradient(90deg, #76B3CD 0%, #518399 100%);
    border-radius: ${theme.radii.pixel.xl}px;
    padding: ${theme.indents.xxxs}px;
    padding-right: ${theme.indents.xxs}px;

    div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    ${RoundingFramedIcon} {
        display: inline-flex;

        svg {
            stroke: ${theme.colors.links.accent};
        }
    `}
`;

ButtonQuiz.displayName = 'ButtonQuiz';

export { ButtonQuiz };
